import { XCircle, ArrowLeft } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Footer } from "@/components/Footer"
import { useBooking } from "@/context/BookingContext"
import { eventPath } from "@/lib/utils"

export default function BookingCancel() {
  const { state } = useBooking()
  const slug = state.event?.slug ?? undefined
  return (
    <div className="min-h-screen">
      <div className="flex min-h-[80vh] items-center justify-center px-4">
        <div className="flex max-w-md flex-col items-center gap-6 text-center">
          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-destructive/20 blur-2xl" />
            <XCircle className="relative size-20 text-destructive" />
          </div>

          <div className="flex flex-col gap-2">
            <h1 className="text-3xl font-bold text-foreground">
              Payment Cancelled
            </h1>
            <p className="text-muted-foreground">
              Your payment was not completed and no charges have been made. Your
              booking has not been confirmed.
            </p>
          </div>

          <div className="flex items-center gap-3 rounded-xl border border-border bg-card px-5 py-4">
            <p className="text-sm text-foreground">
              You can return to your booking and try again, or go back to the
              homepage to start over.
            </p>
          </div>

          <div className="flex w-full flex-col gap-3">
            <Button
              size="lg"
              onClick={() => {
                window.history.back()
              }}
            >
              <ArrowLeft className="mr-2 size-4" />
              Try Again
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={() => {
                window.location.href = eventPath(slug)
              }}
            >
              Back to Homepage
            </Button>
          </div>
        </div>
      </div>
      <Footer eventSlug={slug} />
    </div>
  )
}
